// src/features/documents/components/DocumentBuilder/index.jsx
import React, { useState, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import Button from '../../../../shared/components/ui/Button';
import PrintableDocument from './PrintableDocument';
import styles from './DocumentBuilder.module.css';

const DocumentBuilder = ({ settings }) => {
  const printRef = useRef(null);

  const [docTitle, setDocTitle] = useState('فاتورة خدمات');
  const [docNum,   setDocNum]   = useState('INV-0025');
  const [docDate,  setDocDate]  = useState(new Date().toISOString().slice(0, 10));
  const [dueDate,  setDueDate]  = useState('');
  const [party1,   setParty1]   = useState('محمد أحمد الكريمي');
  const [phone,    setPhone]    = useState('07701234567');
  const [notes,    setNotes]    = useState('الدفع خلال 7 أيام من تاريخ الاستلام.');
  const [sigs,     setSigs]     = useState(['الطرف الأول', 'الطرف الثاني']);

  const addSig    = () => setSigs(p => [...p, 'توقيع']);
  const removeSig = i  => setSigs(p => p.filter((_, x) => x !== i));
  const editSig   = (i, v) => setSigs(p => p.map((s, x) => x === i ? v : s));

  /* ✅ إصلاح: contentRef بدلاً من content */
  const handlePrint = useReactToPrint({
    contentRef: printRef,
    documentTitle: docTitle,
    pageStyle: `
      @page { size: A4 portrait; margin: 14mm; }
      @media print { html, body { margin: 0; padding: 0; } }
    `,
  });

  return (
    <div className={styles.shell}>

      {/* ══ اللوحة الجانبية ══ */}
      <aside className={styles.panel}>

        <section className={styles.sec}>
          <p className={styles.secTitle}>المستند</p>
          <div className={styles.field}>
            <label className={styles.lbl}>العنوان</label>
            <input className={styles.inp} value={docTitle} onChange={e => setDocTitle(e.target.value)} />
          </div>
          <div className={styles.twoCol}>
            <div className={styles.field}>
              <label className={styles.lbl}>رقم المستند</label>
              <input className={styles.inp} value={docNum} onChange={e => setDocNum(e.target.value)} />
            </div>
            <div className={styles.field}>
              <label className={styles.lbl}>تاريخ الإصدار</label>
              <input type="date" className={styles.inp} value={docDate} onChange={e => setDocDate(e.target.value)} />
            </div>
          </div>
          <div className={styles.field}>
            <label className={styles.lbl}>
              تاريخ الاستحقاق <span className={styles.opt}>(اختياري)</span>
            </label>
            <input type="date" className={styles.inp} value={dueDate} onChange={e => setDueDate(e.target.value)} />
          </div>
        </section>

        <section className={styles.sec}>
          <p className={styles.secTitle}>بيانات الطرف الثاني</p>
          <div className={styles.field}>
            <label className={styles.lbl}>الاسم</label>
            <input className={styles.inp} value={party1} onChange={e => setParty1(e.target.value)} />
          </div>
          <div className={styles.field}>
            <label className={styles.lbl}>رقم الهاتف</label>
            <input className={styles.inp} value={phone} onChange={e => setPhone(e.target.value)} />
          </div>
        </section>

        <section className={styles.sec}>
          <p className={styles.secTitle}>ملاحظات / شروط</p>
          <textarea className={styles.textarea} rows={3} value={notes} onChange={e => setNotes(e.target.value)} />
        </section>

        <section className={styles.sec}>
          <p className={styles.secTitle}>التوقيعات</p>
          {sigs.map((s, i) => (
            <div key={i} className={styles.sigRow}>
              <input className={styles.inp} value={s} onChange={e => editSig(i, e.target.value)} />
              <button className={styles.iconBtn} onClick={() => removeSig(i)}>×</button>
            </div>
          ))}
          <button className={styles.addBtn} onClick={addSig}>＋ توقيع</button>
        </section>

        <div className={styles.printArea}>
          <Button variant="primary" size="lg" fullWidth onClick={handlePrint}>
            طباعة / PDF
          </Button>
        </div>

      </aside>

      {/* ══ منطقة الورقة ══ */}
      <div className={styles.canvas}>
        <div className={styles.canvasBar}>
          <span className={styles.hint}>
            ✏️ انقر على الخلية للتعديل — اسحب الحد لتغيير العرض
          </span>
          <button className={styles.printSm} onClick={handlePrint}>🖨 طباعة</button>
        </div>
        <div className={styles.pageWrap}>
          <PrintableDocument
            ref={printRef}
            settings={settings}
            docTitle={docTitle}
            docNum={docNum}
            docDate={docDate}
            dueDate={dueDate}
            party1={party1}
            phone={phone}
            notes={notes}
            sigs={sigs}
          />
        </div>
      </div>

    </div>
  );
};

export default DocumentBuilder;